function openCity(evt, tabName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(tabName).style.display = "block";
  evt.currentTarget.className += " active";
}

const headerMenu = document.getElementById('ctHeader');
// Function to remove the class
function removeClass() {
  headerMenu.classList.remove('opacityZero');
}
// Set a timeout to call the function after 5 seconds
setTimeout(removeClass, 500)

// light box gallery open
$(document).ready(function(){
  $(".product__media-icon--lightbox").click(function(){  
      $('.media-modal').attr('open' , 'open');
     $('body').addClass('overflow-hidden')
  });
});




